/* eslint no-shadow: ["error", { "allow": ["state"] }] */

// initial state
export const state = {
  /*
    Each item in the errors array will be structured as follows:
    {
      id: String,
      code?: Number,
      isWarning?: Boolean,
      message: String,
      icon?: String,
    }
  */
  errors: [],
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
export const mutations = {
  setBlockingErrors(state, data) {
    state.errors = state.errors.concat(data);
  },
  removeAllBlockingErrors(state) {
    state.errors = [];
  },
  removeBlockingError(state, errId) {
    state.errors = state.errors.filter((err) => err.id !== errId);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
